import { createFileRoute, Outlet } from '@tanstack/react-router';

import Layout from '@/screens/chat/skills/id/layout';

export const Route = createFileRoute('/_app/_chat/skills/$id')({
  component: LayoutRoute,
});

function LayoutRoute() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}
